export default "__VITE_ASSET__EuXSjveV__"